











































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import "@/styles/iucn/filter.css";
import "@/styles/iucn/main-content.css";
import ReviewFilter from "./Filter/ReviewFilter.vue";
import ExtReviewSubLayoutComponent from "./ExtReviewSubLayout.vue";
import IntReviewSubLayoutComponent from "./IntReviewSubLayout.vue";
import { ReportFilter, ReportParameter } from "@/entities";
import { http } from "@/shared/https";

@Component({
  components: {
    ReviewFilter,
    ExtReviewSubLayoutComponent,
    IntReviewSubLayoutComponent,
  },
})
export default class AppReviewLayoutComponent extends Vue {
  @Prop() entity!: any;
  filters: any = [];
  items: Array<any> = [];
  filterData = [];
  activeFilter: any;
  collapsed = false;
  reviews: Array<any> = [];
  reviewType = 0;
  updatekey = 0;
  get type() {
    return [
      { text: this.$t("GPOU Reviews").toString(), value: 0 },
      { text: this.$t("TAG Reviews").toString(), value: 1 },
    ];
  }
  tabs = [
    {
      component: "IntReviewSubLayoutComponent",
      icon: "mdi-grid-large",
      url: "/api/ReviewInternal",
    },
    {
      component: "ExtReviewSubLayoutComponent",
      icon: "mdi-table-large",
      url: "/api/ReviewExternal/TagReviews",
    },
  ];
  currentTab = this.tabs[0];
  ddConclusion = _app.ddConclusion;

  mounted() {
    // this.type.map(x => {
    //   x.text = this.$t(x.text);
    //   return x
    // });
    this.getFilters();
    this.getLeftPanelFilter();
    let localData = localStorage.getItem('filterBy');
    if(localData == "{}")
    {
      this.listReviews(this.activeFilter);
    }
    else
    {
      var newFilterData = "";
      var filterLst = JSON.parse(localData);
      Object.entries(filterLst).forEach(([key, value]) => {       
        newFilterData = newFilterData == "" ? key + "=" + value : (newFilterData + "&" + key + "=" + value);       
      }); 

      this.activeFilter = newFilterData;
      this.listReviews(this.activeFilter);
    }
  }

  collapseFilter() {
    this.collapsed = !this.collapsed;
  }

  get currentTabComponent() {
    return this.currentTab.component;
  }

  getFilters() {
    http.get(`api/ReviewExternal/AdvanceFilter`).then((resp: any) => {
      if (resp.status >= 200 && resp.status < 300 && resp.data) {
        this.filters = resp.data;
      }
    });
  }

  getLeftPanelFilter() {
      http.get(`api/ReviewInternal/GetFilter`).then((resp: any) => {
      if (resp.status >= 200 && resp.status < 300) {
        this.items = resp.data;
      }
    })
  }

  listReviews(e) {
    let filteredData = '';
    const self = this;
    self.activeFilter = e;
    http
      .get(`${this.currentTab.url}/${this.entity}?${self.activeFilter || ""}`)
      //.get(`${this.currentTab.url}?${self.activeFilter || ""}`)
      .then((resp: any) => {
        if (resp.status >= 200 && resp.status < 300) {
          if (resp.data && resp.data.Items) {
            self.reviews = resp.data.Items.map((x) => {
              switch (x.DDReviewConclusion) {
                case 1:
                  x.DDReviewConclusion = this.$t(self.ddConclusion.find(
                    (y) => y.value === x.DDReviewConclusion
                  ).label);
                  break;
                case 2:
                  x.DDReviewConclusion = this.$t(self.ddConclusion.find(
                    (y) => y.value === x.DDReviewConclusion
                  ).label);
                  break;
                case 3:
                  x.DDReviewConclusion = this.$t(self.ddConclusion.find(
                    (y) => y.value === x.DDReviewConclusion
                  ).label);
                  break;
              }
              return x;
            });
          }
          self.reviews = resp.data.Items || [];          
          if(resp.data.Filters != null)
          {
            filteredData = JSON.stringify(resp.data.Filters);
          }
          let initialFilter = JSON.stringify(self.items);
          if(filteredData && filteredData !== initialFilter){
            self.items = resp.data.Filters;
          }
        }
        
      });
  }

  @Watch("reviewType") typeChange(newVal) {
    this.reviews = [];
    this.currentTab = this.tabs[newVal];
    this.listReviews(this.activeFilter);
    this.updatekey += 1;
  }

  onSearch(selectedParams: Array<ReportParameter>) {
    if (this.currentTab.component == "ExtReviewSubLayoutComponent") {
      http
        .post(`api/ReviewExternal/${this.entity}/Filter`, selectedParams)
        .then((resp: any) => {
          if (resp.status >= 200 && resp.status < 300) {
            this.reviews = resp.data.Items || [];
          }
        });
    } else {
      http
        .post(`api/ReviewInternal/${this.entity}/Filter`, selectedParams)
        .then((resp: any) => {
          if (resp.status >= 200 && resp.status < 300) {
            let items = resp.data.Items;
            if(items){
            items = resp.data.Items.map((x) => {
              switch (x.DDReviewConclusion) {
                case 1:
                  x.DDReviewConclusion = this.$t(this.ddConclusion.find(
                    (y) => y.value === x.DDReviewConclusion
                  ).label);
                  break;
                case 2:
                  x.DDReviewConclusion = this.$t(this.ddConclusion.find(
                    (y) => y.value === x.DDReviewConclusion
                  ).label);
                  break;
                case 3:
                  x.DDReviewConclusion = this.$t(this.ddConclusion.find(
                    (y) => y.value === x.DDReviewConclusion
                  ).label);
                  break;
              }

              return x;
            });
            }
            this.reviews = items || [];
          }
        });
    }
  }
}
